import { render, staticRenderFns } from "./PurchaseOrderRemarks.vue?vue&type=template&id=0acd07ac"
import script from "./PurchaseOrderRemarks.vue?vue&type=script&lang=js"
export * from "./PurchaseOrderRemarks.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports